'use strict';
import template from './dialog-content.html';

export const MxDialogContentComponent = {
	bindings: {
		contentWidgetId: '=?',
		objectId: '=?',
		view: '=?',
		enableConcurrencyTracking: '=?',
		dialogType: '=?',
		extraContext: '=?',
		mergeDisabled: '<',
	},
	controller: MxCommonDialogContentCtrl,
	controllerAs: 'vm',
	template: template,
};

MxCommonDialogContentCtrl.$inject = [
	'$scope',
	'$element',
	'$q',
	'$timeout',
	'mx.shell.EventService',
	'mx.SolutionBuilderAgent.ContentWidgetService',
	'mx.shell.SidePanelService',
	'mx.SolutionBuilderAgent.ConcurrencyTrackingService',
	'mx.shell.NotificationService',
	'mx.internationalization',
	'mx.SolutionBuilderAgent.designerOpener',
	'mx.app.DeviceService',
	'mx.shell.ActionProviderService',
	'mx.SolutionBuilderAgent.ExternalServiceManager',
	'mx.shell.AppsService',
	'mx.shell.ObjectMapper',
	'mx.SolutionBuilderAgent.mxColumnDefinitionService',
	'mx.SolutionBuilderAgent.DataModelService',
	'mx.SolutionBuilderAgent.SchemaService',
	'mx.SolutionBuilderAgent.DeepLinkingService',
];

export function MxCommonDialogContentCtrl(
	$scope,
	$element,
	$q,
	$timeout,
	eventService,
	contentWidgetService,
	sidePanelService,
	concurrencyTrackingService,
	notificationService,
	i18n,
	designerOpener,
	deviceService,
	actionProviderService,
	externalServiceManager,
	appService,
	objectMapper,
	dataQueryService,
	dataModelService,
	schemaService,
	deepLinkingService
) {
	const vm = this;
	let defaultErrorMessage, statusDisabled;
	let viewOptions = deepLinkingService.parseViewOptionsFromUrl();

	let formReadOnly = false;
	let reloadPageOnSave = false;

	Object.defineProperty(vm, 'formReadOnly', {
		get: function () {
			return formReadOnly;
		},
		set: function (value) {
			formReadOnly = value;

			vm.updateFormStatus();
		},
	});

	vm.setFormReadOnly = function () {
		vm.readOnly = true; // this flag is set to mxForm.readOnly what is fired mxForm.onReadOnlyChanged and set value to formReadOnly
	};

	vm.subscriptions = [];
	vm.isDeleted = false;

	vm.dialogContainerViews = viewOptions && viewOptions.viewId ? [viewOptions.viewId] : undefined;

	vm.$onInit = function () {
		if (vm.view.readOnly || (vm.view.parentView && vm.view.parentView.readOnly) || vm.view.dialogInsteadOfPreview) {
			vm.setFormReadOnly();
		}
		vm.entity = {};
		vm.entityName = undefined;
		vm.loaded = false;
		vm.errors = [];
		vm.onViewSubmit = onViewSubmit;
		vm.close = closeDialog;
		vm.confirm = true;
		vm.showWarning = false;

		vm.disabled = false;
		vm.reloadObject = reloadObject;

		vm.warningMessage = i18n.get('solutionBuilderAgent.layouts.dialog.dialog-content.concurrencyObjectOutdated');
		vm.warningMessageButtonLabel = i18n.get('solutionBuilderAgent.layouts.dialog.dialog-content.concurrencyConfirmYes');
		vm.warningMessageButtonHandler = function () {
			reloadObject();
		};

		defaultErrorMessage = i18n.get('solutionBuilderAgent.layouts.dialog.dialog-content.object-not-saved');

		statusDisabled = false;

		if (!vm.contentWidgetId) {
			throw new Error(i18n.get('solutionBuilderAgent.layouts.errors.content_widget_not_provided'));
		}

		if (!vm.objectId) {
			throw new Error(i18n.get('solutionBuilderAgent.layouts.errors.object_identifier_is_not_provided'));
		}

		vm.objectDetailsMode = vm.dialogType === mx.SolutionBuilderAgent.ContentWidgetDialogAction.Preview;
		vm.contextWidgetType = vm.objectDetailsMode ? mx.SolutionBuilderAgent.ContentWidgetType.ObjectDetails : mx.SolutionBuilderAgent.ContentWidgetType.Dialog;

		if (
			!vm.objectDetailsMode &&
			vm.enableConcurrencyTracking &&
			vm.objectId.toLowerCase() !== 'new' &&
			vm.dialogType !== mx.SolutionBuilderAgent.ContentWidgetDialogAction.New &&
			!externalServiceManager.isService(vm.entityName || vm.view.context._type)
		) {
			vm.subscriptions.push(subscribeConcurrency());
		}

		if (vm.view && vm.view.finishDefer) {
			vm.view.finishDefer.promise.catch(mx.logCatch).finally(function () {
				stopEditing();
			});
		}
	};

	vm.disableSaveActions = function () {
		statusDisabled = true;
		vm.formIsLoading = true;
		vm.updateFormStatus();
	};

	vm.enableSaveActions = function () {
		statusDisabled = false;
		vm.formIsLoading = false;
		vm.updateFormStatus();
	};

	vm.setValidationStatus = function (isFormValid) {
		vm.isFormValid = isFormValid;
		vm.updateFormStatus();
	};

	vm.updateFormStatus = function () {
		vm.view.saveDisabled = statusDisabled || vm.formReadOnly || !vm.isFormValid;
	};

	var _confirmationDialog = {};
	Object.defineProperty(vm, 'confirmationDialog', {
		get: function () {
			return _confirmationDialog;
		},
		set: function (value) {
			_confirmationDialog = value;
		},
	});

	var onChangeConfirmationDialogResultHandlers = [];
	vm.onChangeConfirmationDialogResult = function (callBack) {
		if (typeof callBack === 'function') {
			onChangeConfirmationDialogResultHandlers.push(callBack);
		}
	};

	Object.defineProperty(vm, 'confirmationDialogResult', {
		set: function (value) {
			onChangeConfirmationDialogResultHandlers.forEach(function (callback) {
				callback(value);
			});
		},
	});

	var eventDialogActionExecuted = eventService.subscribeTo(
		mx.SolutionBuilderAgent.Events.DialogActionExecuted,
		function (eventObj, params) {
			if (params.view === vm.view) {
				if (params.action === 0) {
					closeDialog();
				} else {
					var enableConfirmationDialog =
						vm.confirmationDialog.enabled &&
						!(
							vm.confirmationDialog.disabledWhenNoChanges &&
							vm.view.context.$$initialEntity === dataModelService.serializeObject(dataModelService.cleanFromEmptyOptionalDataDefinition(vm.view.context))
						);

					if (enableConfirmationDialog && Array.isArray(vm.confirmationDialog.actions) && vm.confirmationDialog.actions.length > 0) {
						var dialogConfig = {
							id: 'ActionOnPreSaveDialog',
							title: vm.confirmationDialog.title,
							message: vm.confirmationDialog.message,
							actions: [],
							notSaved: true,
							buttonsInActionZone: true,
						};

						dialogConfig.actions = vm.confirmationDialog.actions
							.sort(function (a, b) {
								return (a.position || 0) - (b.position || 0);
							})
							.map(function (item) {
								return {
									id: item.name,
									title: item.title,
									notForSave: item.notSave,
									isConfirmButton: item.isConfirmButton,
								};
							});

						sidePanelService.showConfirmationDialog(dialogConfig).then(function (answer) {
							vm.confirmationDialogResult = answer;
							var button = _.find(vm.confirmationDialog.actions, { name: answer });
							if (button === undefined || !button.notSave) {
								$timeout(function () {
									onViewSubmit(params.action === 2, params.view);
								}, 400);
							}
						});
					} else {
						onViewSubmit(params.action === 2, params.view);
					}
				}
			}
		},
		$scope
	);

	vm.subscriptions.push(eventDialogActionExecuted);

	var objectDataDeleted = eventService.subscribeTo(
		mx.SolutionBuilderAgent.Events.ObjectDataDeleted,
		function (eventObj, data) {
			if (data && Array.isArray(data.affectedObjectIds)) {
				var closeCurrentView = data.affectedObjectIds.some(function (value) {
					return vm.objectId.toLowerCase() === value.toLowerCase();
				});

				if (closeCurrentView && sidePanelService.currentView !== vm.view) {
					closeDialog();
				}
			}
		},
		$scope
	);

	vm.subscriptions.push(objectDataDeleted);

	$element.on('$destroy', function () {
		stopEditing();
		$scope.$destroy();
	});

	Object.defineProperties(vm, {
		viewIsDirty: {
			get: function () {
				return vm.view.dirty;
			},
			set: function (newValue) {
				if (vm.view.dirty !== newValue) {
					vm.view.dirty = newValue;
					eventService.dispatchEvent(mx.SolutionBuilderAgent.Events.ViewDirtyStatusChanged, vm.view);
				}
			},
		},
		reloadPageOnSave: {
			get: function () {
				return reloadPageOnSave;
			},
			set: function (newValue) {
				reloadPageOnSave = newValue;
			},
		},
	});

	return vm;

	function subscribeConcurrency() {
		return concurrencyTrackingService.subscribe(vm.objectId, {
			change: function (objectId, userId, username) {
				if (vm.confirm) {
					showObjectChangedNotification(username, false);
				}
			},
			delete: function (objectId, userId, username) {
				vm.isDeleted = true;
				showObjectDeletedNotification(username);
			},
			subscribe: function (userName) {
				notificationService.info(
					i18n.getFormatted(
						'solutionBuilderAgent.layouts.dialog.dialog-content.concurrencySubscribed',
						userName || i18n.get('solutionBuilderAgent.layouts.dialog.dialog-content.concurrencyUnknownUser'),
						getDisplayName() || i18n.get('solutionBuilderAgent.layouts.dialog.dialog-content.concurrencyConfirmDefaultItemName')
					)
				);
			},
			unsubscribe: function (userName) {
				notificationService.info(
					i18n.getFormatted(
						'solutionBuilderAgent.layouts.dialog.dialog-content.concurrencyUnsubscribed',
						userName || i18n.get('solutionBuilderAgent.layouts.dialog.dialog-content.concurrencyUnknownUser'),
						getDisplayName() || i18n.get('solutionBuilderAgent.layouts.dialog.dialog-content.concurrencyConfirmDefaultItemName')
					)
				);
			},
			exist: function (userNames) {
				var msg =
					userNames.length === 1
						? i18n.getFormatted(
								'solutionBuilderAgent.layouts.dialog.dialog-content.concurrencySubscriptionExist',
								userNames[0] || i18n.get('solutionBuilderAgent.layouts.dialog.dialog-content.concurrencyUnknownUser'),
								getDisplayName() || i18n.get('solutionBuilderAgent.layouts.dialog.dialog-content.concurrencyConfirmDefaultItemName')
						  )
						: i18n.getFormatted(
								'solutionBuilderAgent.layouts.dialog.dialog-content.concurrencySubscriptionsExist',
								userNames.length,
								getDisplayName() || i18n.get('solutionBuilderAgent.layouts.dialog.dialog-content.concurrencyConfirmDefaultItemName')
						  );

				notificationService.info(msg);
			},
		});
	}

	function callFunctions(names) {
		if (!names.length) {
			return $q.when();
		}
		return $q.all(
			names.map(function (m) {
				return dataModelService.reloadSourceByPath(m, vm.entity, vm.contentWidgetId);
			})
		);
	}

	function onViewSubmit(saveAndClose) {
		vm.confirm = false;
		var isNew = vm.entity[vm.entityName].IsNew; // Name

		var savingFunctionNames = vm.widget.extensions.Sources.filter(function (w) {
			return w.OnSaving;
		}).map(function (m) {
			return m.Name;
		});
		var savedFunctionNames = vm.widget.extensions.Sources.filter(function (w) {
			return w.OnSaved;
		}).map(function (m) {
			return m.Name;
		});
		vm.disableSaveActions();

		return callFunctions(savingFunctionNames).then(
			function () {
				return (
					externalServiceManager.isService(vm.widget.entity)
						? externalServiceManager.updateEntity(vm.widget.entity, vm.objectId, vm.entity[vm.entityName]).then(function (objectId) {
								vm.objectId = objectId;
								if (vm.entity === 'service_6886d8dc-51f8-e611-9382-f079595b3ec7') {
									schemaService.clearClasses();
								} else if (vm.entity === 'service_7b83787c-81f7-e611-9382-f079595b3ec7') {
									schemaService.clearTypes();
								}
								return {
									entity: vm.entity[vm.entityName],
								};
						  })
						: $q
								.when(null, function () {
									vm.entity[vm.entityName].ID = vm.objectId;
									return contentWidgetService.updateDialogData(vm.widget.id, vm.entity[vm.entityName]);
								})
								.then(function (data) {
									if (vm.view && vm.view.context) {
										vm.view.context._displayName = data.Entity['Sys-DisplayName'] || data.Entity['Sys-Name'];
									}

									if (isNew) {
										vm.objectId = data.Entity.ID;
										vm.name = data.Entity['Sys-Name'] || data.Entity['Sys-DisplayName'];
										if (vm.view && vm.view.context) {
											vm.view.context._name = vm.name;
										}
										if (
											deviceService.screenDesktop() === true &&
											(vm.widget.entity === 'PDRContentWidgetTypeDialog' ||
												vm.widget.entity === 'PDRContentWidgetTypeList' ||
												vm.widget.entity === 'PDRContentWidgetTypeObjectDetails' ||
												vm.widget.entity === 'PDRContentWidgetTypeWizard' ||
												vm.widget.entity === 'PDRContentWidgetTypeEmail' ||
												vm.widget.entity === 'PDRContentWidgetTypeLandingPage')
										) {
											eventService.dispatchEvent(mx.SolutionBuilderAgent.Events.NewWidgetCreated, vm.objectId);
											actionProviderService.getActions(true).then(function () {
												eventService.dispatchEvent(mx.shell.EventCodes.NavigationReload);
												designerOpener.open(vm.widget.entity, vm.objectId);
												notificationService.info(i18n.get('solutionBuilderAgent.services.contentWidget.popusBlocking'));
											});
										} else if (vm.widget.entity === 'PDRNavigationItemType') {
											eventService.dispatchEvent(mx.shell.EventCodes.NavigationReload);
										} else if (vm.widget.entity === 'PDRActionType') {
											actionProviderService.getActions(true).then(function () {
												eventService.dispatchEvent(mx.shell.EventCodes.NavigationReload);
											});
										}

										if (!saveAndClose) {
											vm.subscriptions.push(subscribeConcurrency());
										}
									} else {
										_.merge(vm.entity[vm.entityName], data.Entity);

										switch (vm.widget.entity) {
											case 'PDRDataQueryType':
												dataQueryService.removeFromCache(vm.objectId);
												break;
											case 'SPSGlobalConfigurationType': {
												const administrationSettingsDialogId = '7f02b055-475a-cd03-c022-08d3c0535c55';
												if (vm.widget.id === administrationSettingsDialogId) {
													eventService.dispatchEvent(mx.shell.EventCodes.NavigationReload);
												}
												break;
											}
										}
									}

									if (vm.widget.entity === 'PDRApplicationType') {
										appService.reloadApplications();
									}

									callFunctions(savedFunctionNames).then(function () {});

									return {
										entity: objectMapper.mapItem(vm.entity[vm.entityName]),
										newEntityType: data.Entity && vm.widget.entity !== data.Entity['Sys-Entity'] ? data.Entity['Sys-Entity'] : undefined,
									};
								})
				).then(
					function (entityData) {
						if (vm.reloadPageOnSave) {
							window.location.reload();
						}

						const entity = entityData.entity;
						vm.view.context = entity;

						var newEntityType = entityData.newEntityType;
						notificationService.success(i18n.get('solutionBuilderAgent.layouts.dialog.dialog-content.object-saved'));
						eventService.dispatchEvent(mx.SolutionBuilderAgent.Events.SearchPageDataChanged, {
							affectedEntity: entity,
						});

						if (newEntityType) {
							var oldEntityType = vm.entityName;
							vm.widget.entity = newEntityType;
							entity['Sys-Entity'] = newEntityType;
							entity._type = newEntityType;

							eventService.dispatchEvent(mx.SolutionBuilderAgent.Events.ObjectTypeChanged, {
								objectId: vm.objectId,
								entityType: oldEntityType,
								newEntityType: newEntityType,
								displayName: entity['Sys-DisplayName'],
							});
						}

						eventService.dispatchEvent(mx.SolutionBuilderAgent.Events.ObjectDataChanged, {
							affectedObjectIds: [vm.objectId],
							view: vm.view,
						});

						if (saveAndClose) {
							submitDialog(entity);
						} else {
							if (isNew && !vm.view.context) {
								vm.view.context = objectMapper.mapItem(entity);
								vm.view.context._type = vm.view.context._type || vm.entityName || vm.view.type;
								vm.view.context._displayName = vm.view.context._name;
							}

							var newDialogType;
							if (vm.dialogType === mx.SolutionBuilderAgent.ContentWidgetDialogAction.New) {
								newDialogType = mx.SolutionBuilderAgent.ContentWidgetDialogAction.Edit;
							}

							if (vm.view) {
								// if "save" button was clicked then finishDefer should will be resolved in any way
								// even if "cancel" button is clicked after "save"
								// for this case finishDefer is replaced for new defer
								// if finishDefer is rejected from side-panel (closeView) then saved entity will be re resolved to savedDefer
								if (!vm.view.savedDefer) {
									vm.view.savedDefer = vm.view.finishDefer;
									vm.view.finishDefer = $q.defer();
									vm.view.finishDefer.promise.catch(mx.logCatch).finally(function () {
										vm.view.savedDefer.resolve(entity);
									});
								}

								vm.view.isRefreshable = true;

								if (newDialogType || newEntityType) {
									eventService.dispatchEvent(mx.shell.EventCodes.RefreshCurrentView, {
										view: vm.view,
										newDialogType: newDialogType,
										newEntityType: newEntityType,
									});
								} else {
									reloadObject();
								}
							}
						}

						vm.enableSaveActions();
					},
					function (error) {
						if (concurrencyTrackingService.isUpdateConflict(error)) {
							showObjectChangedNotification('', saveAndClose);
						} else if (concurrencyTrackingService.isDeleted(error)) {
							vm.isDeleted = true;
							showObjectDeletedNotification();
						} else {
							var errorData = error && error.data;
							var errorMsg = (errorData && error.data.Message) || (typeof errorData === 'string' && errorData);
							vm.errors = [errorMsg || defaultErrorMessage];
							vm.enableSaveActions();
						}
					}
				);
			},
			function () {
				vm.enableSaveActions();
			}
		);
	}

	function getDisplayName() {
		return vm.name || vm.view.name || '';
	}

	function showObjectDeletedNotification(userName) {
		userName = userName || '';

		concurrencyTrackingService.showObjectDeletedNotification(userName, getDisplayName(), vm.view).then(function (answer) {
			eventService.dispatchEvent(mx.SolutionBuilderAgent.Events.SearchPageDataChanged);

			if (answer === 'close') {
				closeDialog(vm.view);
			} else {
				setObjectDeleted();
			}
		});
	}

	function showObjectChangedNotification(userName = '', saveAndClose = false) {
		vm.confirm = false;
		var entity = vm.entity[vm.entityName];

		concurrencyTrackingService
			.showObjectChangedNotification(userName || '', getDisplayName(), {
				view: vm.view,
				entityName: vm.entityName,
				startEntityValue: entity.$$initialEntity,
				finishEntityValue: dataModelService.serializeObject(dataModelService.cleanFromEmptyOptionalDataDefinition(entity)),
				widgetId: vm.widget.id,
				objectId: vm.objectId,
			})
			.then(function (data) {
				switch (data.answer) {
					case 'merge':
						_.merge(vm.entity[vm.entityName], data.entity);
						if (data.save) {
							onViewSubmit(false, vm.view);
						} else {
							vm.confirm = true;
							vm.enableSaveActions();
						}
						break;
					case 'reload':
						reloadObject();
						break;
					case 'cancel':
						if (vm.view.mergeDisabled) {
							setObjectOutdated();
						} else {
							vm.confirm = true;
							vm.enableSaveActions();
						}
						break;
					case 'no-changes':
						if (saveAndClose) {
							submitDialog(entity);
						} else {
							vm.confirm = true;
							vm.enableSaveActions();
						}
				}
			});
	}

	function setObjectOutdated() {
		vm.formIsLoading = false;
		vm.showWarning = true;
		vm.warningMessage = i18n.get('solutionBuilderAgent.layouts.dialog.dialog-content.concurrencyObjectOutdated');
		vm.setFormReadOnly();
	}

	function setObjectDeleted() {
		vm.formIsLoading = false;
		vm.errors = [
			{
				message: i18n.get('solutionBuilderAgent.layouts.dialog.dialog-content.concurrencyObjectDeleted'),
				type: 'warning',
				active: true,
			},
		];
		vm.setFormReadOnly();
	}

	function reloadObject() {
		eventService.dispatchEvent(mx.shell.EventCodes.RefreshCurrentView, {
			view: vm.view,
		});
	}

	function unsubscribeFromEvents() {
		vm.subscriptions.forEach(function (unsubscribe) {
			unsubscribe();
		});

		vm.subscriptions = [];
	}

	function stopEditing() {
		unsubscribeFromEvents();
	}

	function submitDialog(entity) {
		if (vm.view) {
			if (vm.view.finishDefer) {
				vm.view.finishDefer.resolve(entity);
			}
		}
	}

	function closeDialog() {
		if (vm.view) {
			if (vm.view.finishDefer) {
				vm.view.finishDefer.reject(mx.noLogCatchMessage('close dialog'));
			}
		}
	}
}
